import React, { useEffect, useState } from 'react';
import feedbackReview from '../../../assets/img/starbg.svg';
import { useStore } from '../../../hooks/useStore';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';
import APIServices from '../../../services/APIServices';
import { selectLoader } from '../../../utils/Helpers';
import { fetchEnumOptions } from 'utils/fetchData';
import { use } from 'react';

const RejectRequestModal = ({ requestId = '', closeModal }) => {
  const [isLoading, setLoading] = useState(false);
  const [note, setNote] = useState('');

  const handleReject = async () => {
    if (!note.trim()) {
      appToast('Please enter a reason for rejection.', TOAST_TYPE.ERROR);
      return;
    }

    try {
      setLoading(true);

      const response = await APIServices.put(`/project-requests/${requestId}/reject`, { reason: note });

      if (response?.message || response?.data?.message) {
        appToast(response.message || response.data.message, TOAST_TYPE.SUCCESS);
      }

      closeModal(); // close modal after success
    } catch (error) {
      console.error(error);
      appToast('Failed to reject request.', TOAST_TYPE.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="override-body">
      <div className="override-formgroup">
        <label>Reason for Reject</label>
        <textarea
          placeholder="Explain why you are rejecting this request."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>

      <div className="modal-footer">
        <button className="delet-btn" type="button" onClick={handleReject} disabled={isLoading}>
          {isLoading ? selectLoader(20) : 'Reject'}
        </button>
      </div>
    </div>
  );
};
export default RejectRequestModal;
